import { IModule, IModuleBuilder } from "app/IModule";
import {BidsComponentPage} from "./BidsComponent";

export default class BidsModule implements IModule {
    build(builder: IModuleBuilder) {
        builder.addRoute("/component/bids", BidsComponentPage);
    }
}